<template>
  <custom-dialog
    :title="$t('asm_add_case_dialog.xin_zeng_an_li')"
    :visible="visible"
    v-on="$listeners"
    width="1000px"
    class="fault-add-case-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="info-content">
        <div class="item-title">{{ $t('asm_add_case_dialog.she_bei_xin_xi') }}</div>
        <div class="base-info">
          <el-row :gutter="15">
            <el-col :span="8">
              <div class="key">{{ $t('asm_add_case_dialog.chan_pin_xing_hao') }}：</div>
              <div class="val">{{info.productCode}}</div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_add_case_dialog.ji_shen_hao') }}：</div>
              <div class="val">{{info.bodyNum}}</div>
            </el-col>
            <el-col
              :span="8"
              v-if="type === 'fault'"
            >
              <div class="key">{{ $t('asm_add_case_dialog.he_tong_bian_hao') }}：</div>
              <div class="val">{{info.contractNo}}</div>
            </el-col>
            <el-col
              :span="8"
              v-else
            >
              <div class="key">{{ 'Offline Days' }}：</div>
              <div class="val">{{info.offlineDays}}</div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <div class="key">{{ $t('asm_add_case_dialog.zu_lin_fang') }}：</div>
              <div class="val">{{info.customerName}}</div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_add_case_dialog.shou_hou_gong_si') }}：</div>
              <div class="val">{{info.afterServiceName}}</div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_add_case_dialog.xiang_mu') }}：</div>
              <div class="val">{{info.locationName}}</div>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <div class="key">{{ $t('asm_add_case_dialog.lian_xi_ren') }}：</div>
              <!-- <div class="val">{{info.projectContactName}}</div> -->
              <div class="val">
                <el-input
                  :disabled="contactNameDisable"
                  v-model="form.contactName"
                  style="width:180px;"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="8">
              <!-- 联系电话：{{info.projectContactPhone}} -->
              <div class="key">{{ $t('asm_add_case_dialog.lian_xi_dian_hua') }}：</div>
              <div class="val">
                <el-input
                  :disabled="mobileDisable"
                  v-model="form.mobilePhone"
                  style="width:180px;"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="key">{{ $t('asm_add_case_dialog.di_zhi') }}：</div>
              <div class="val">{{info.currentLocation}}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="info-content">
        <div class="item-title">{{ $t('asm_add_case_dialog.gu_zhang_xin_xi') }}</div>
        <el-form
          label-position="top"
          :model="form"
          :rules="rules"
          ref="form"
        >
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item
                :label="$t('asm_add_case_dialog.fu_wu_lei_bie')"
                prop="serviceClass"
              >
                <custom-select
                  code="asm_case_order_service_class"
                  v-model="form.serviceClass"
                  @change="serviceClassChange"
                  @getList="getServiceClassDic"
                  :disabled="true"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('asm_add_case_dialog.chuang_jian_fang_shi')"
                prop="createMode"
              >
                <custom-select
                  :disabled="true"
                  code="asm_case_order_create_mode"
                  v-model="form.createMode"
                ></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <el-form-item
                class="is-required"
                :label="$t('asm_add_case_dialog.qxzhtxgz')"
              >
                <div class="reason-container">
                  <el-button
                    v-for="(item,index) in items"
                    :key="index"
                    @click="selReason(item)"
                    :type="selectedItemIds.includes(item.itemId) ? 'primary' : ''"
                  >{{item.itemName}}</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <el-form-item
                prop="additionalItem"
                class="is-required"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  :placeholder="$t('asm_add_case_dialog.cgzxqhtxqtyy')"
                  v-model="form.additionalItem"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <el-form-item :label="$t('asm_add_case_dialog.scgztp')">
                <t-upload
                  v-model="form.attachList"
                  :attachType="1"
                  :limit="3"
                  bizType="asm.service.request"
                  ref="caseOrderImage"
                  :autoUpload="false"
                ></t-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_submit') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: { tUpload },
  props: {
    // fault - 故障列表  offlineDevice - 离线设备
    type: {
      type: String,
      default: 'fault'
    }
  },
  data() {
    return {
      form: {
        // 服务类型 asm_case_order_service_class
        serviceClass: '',
        // 创建方式,离线设备createMode要用7-不在线  asm_case_order_create_mode
        createMode: '7',
        // 维修原因  BasicItemList   serviceClass: 10
        itemIds: '',
        // 描述
        additionalItem: '',
        // 联系人
        contactName: '',
        // 联系人电话
        mobilePhone: '',
        // 上传附件
        attachList: [],
      },
      selectDeviceVisible: false,
      selectDeviceModel: {},
      deviceInfo: {},
      serviceClassDicMap: {},

      items: [],
      selectedItemIds: [],
      mobileDisable: false,
      contactNameDisable: false,
    };
  },
  computed: {
    rules() {
      return {
        serviceClass: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
        createMode: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
        additionalItem: {
          validator: this.checkAdditionalItem
        },
        contactName: [
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required')
          },
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
        ],
        mobilePhone: [
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required')
          },
          {
            min: 7,
            max: 15,
            message: this.$t('Common.com_rules_length_range', [7,15])
          },
        ],
      };
    },
    info() {
      return this.model.data || {};
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 判断是否为合法电话
    isPhone(value) {
      const isPhone = /^([0-9]{3,4})?(-)?[0-9]{7,8}$/;
      const isMob = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      return isPhone.test(value.toString()) || isMob.test(value.toString());
    },
    getItems() {
      const reqData = {
        serviceClass: this.form.serviceClass
      };
      return this.$getJSON(apis.BasicItemList, reqData).then((res) => {
        this.items = this.itemIdsFilter(res.data, this.info.productCode);
      });
    },
    itemIdsFilter(list, productCode) {
      let ret = [...list];
      if (productCode) {
        ret = ret.filter(item => item.productCode === productCode);
      }

      return ret;
    },

    itemIdsChange() {
      const itemIds = this.form.itemIds;
      if (itemIds.length) {
        this.$refs.form.clearValidate('additionalItem');
      }
    },
    // additionalItemChange() {
    //   const additionalItem = this.form.additionalItem;
    //   if (additionalItem.length) {
    //     this.$refs.form.clearValidate('itemIds');
    //   }
    // },
    getServiceClassDic(data) {
      const map = {};
      data.forEach((item) => {
        map[item.code] = item.value;
      });
      this.serviceClassDicMap = map;
      this.form.serviceClass = this.serviceClassDicMap.maintain;

      this.getItems().then(() => {
        this.initReason();
      });
    },
    serviceClassChange() {
      this.form.itemIds = [];
    },
    checkAdditionalItem(rule, value, cb) {
      const { additionalItem } = this.form;
      const selectedItemIds = this.selectedItemIds;
      if (additionalItem && additionalItem.length > 200) {
        cb(new Error(this.$t('asm_add_case_dialog.zui_duo200ge_zi_fu')));
        return;
      }
      if (!selectedItemIds.length && (!additionalItem || !additionalItem.length)) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      cb();
    },
    selDeviceConfirm(list) {
      this.info = list[0];
    },
    closeDialog() {
      this.visible = false;
    },
    async onConfirm() {
      if (!this.form.mobilePhone) {
        this.$message.error(this.$t('asm_add_case_dialog.qsrlxdh'));
        return;
      }
      if (!this.isPhone(this.form.mobilePhone)) {
        this.$message.error(this.$t('asm_add_case_dialog.qsrhfdh'));
        return;
      }
      if (!this.form.contactName) {
        this.$message.error(this.$t('asm_add_case_dialog.qsrlxr'));
        return;
      }
      await this.$refs.caseOrderImage.submit();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.$postJSON(apis.caseOrderSave, this.getReqData(), true);
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        }
      });
    },
    getReqData() {
      const { additionalItem, attachList, mobilePhone, serviceClass, createMode, contactName } = this.form;
      const { bodyNum, faultInfoId } = this.info;
      const ret = {
        additionalItem,
        attachList,
        // 必填
        bodyNum,
        faultInfoId,
        mobilePhone,
        itemIds: this.selectedItemIds,
        serviceClass,
        createMode,
        contactName
      };
      if (this.type === 'offlineDevice') {
        ret.isOfflineDevice = true;
      }

      return ret;
    },
    initDialog() {
      this.form.mobilePhone = this.info.projectContactPhone;
      this.form.contactName = this.info.projectContactName;

      if (this.form.mobilePhone) {
        this.mobileDisable = true;
      }
      if (this.form.contactName) {
        this.contactNameDisable = true;
      }
    },

    // 初始化故障项勾选情况
    initReason() {
      const type = this.type;
      // 故障名称
      const eventName = this.info.eventName;
      // 故障项目列表
      const faultItems = this.items;

      // 故障列表-添加案例：若故障项中有 上报的故障名称 ，默认选中，
      // 否则在输入框中 默认 加入 上报的故障名称
      if (type === 'fault') {
        const selectedItem = faultItems.find(item => item.itemName === eventName);
        if (selectedItem) {
          this.selectedItemIds.push(selectedItem.itemId);
        } else {
          if (eventName) {
            this.form.additionalItem = eventName;
          }
        }
      }

      // 离线设备-添加案例：若故障项中有 长时间离线 ，默认选中，
      // 否则在输入框中 默认 加入 长时间离线
      if (type === 'offlineDevice') {
        const defaultEventName = 'Long Time Offline';
        const selectedItem = faultItems.find(item => item.itemName === defaultEventName);
        if (selectedItem) {
          this.selectedItemIds.push(selectedItem.itemId);
        } else {
          this.form.additionalItem = defaultEventName;
        }
      }
    },

    selReason(item) {
      const id = item.itemId;
      if (this.selectedItemIds.includes(id)) {
        this.selectedItemIds = this.selectedItemIds.filter(itemId => itemId !== id);
      } else {
        this.selectedItemIds.push(id);
      }
    }

  },
  created() { },
  mounted() {
    this.initDialog();

  },
};
</script>

<style lang="scss" scoped>
.fault-add-case-dialog {
  .reason-container {
    .el-button {
      margin-bottom: 8px;
    }
  }
  .info-content {
    .key {
      float: left;
      line-height: 32px;
    }
    .val {
      overflow: hidden;
      line-height: 32px;
    }

    .btn-content {
      overflow: hidden;
      .btn-sel-device {
        float: left;
      }
    }
    // .tips {
    //   float: left;
    //   line-height: 32px;
    //   margin-left: 10px;
    // }
    &:nth-child(1) {
      .base-info {
        background: #f9f9f9;
        border-radius: 10px;
        padding: 10px;
        font-size: 12px;
        line-height: 26px;
        margin-top: 15px;
      }
    }
    &:nth-child(2) {
      margin-top: 20px;
    }
  }
}
</style>
